//To return jsx element
import React from "react"
import _ from "./lodashUtils"
import isMobilePhone from "validator/lib/isMobilePhone"
import { Rate, Typography } from "antd"
import { SCREENS } from "../constants/screens"
import moment from "moment"
import { DEFAULT_SPACE_NAME } from "../constants/messages"
import {
  CHOOSE_REQUIRED,
  CHOOSE_OPTIONAL,
  CHOOSE_MAX,
} from "../constants/messages"

export const isPhoneValid = (value) => {
  return isMobilePhone(value, "any", {
    strictMode: true,
  })
}
// derives current user and current partner.
export const getParticpantDetails = (me, partners) => {
  let partner = {}
  const partnerKeys = ["partner1", "partner2"]
  partnerKeys.forEach((key) => {
    if (partners && partners[key] && partners[key].username !== me.username) {
      partner = partners[key]
    }
  })
  return partner
}
export const renderCuisines = (restaurant) => {
  const cuisines = _.get(restaurant, "cuisines", [])
  let cuisineString = ""

  cuisines.forEach((cuisine, index) => {
    if (index === cuisines.length - 1) {
      cuisineString = `${cuisineString}${cuisine}`
    } else {
      cuisineString = `${cuisineString}${cuisine}, `
    }
  })

  if (cuisines) {
    return <div className="restaurant-cuisines">{cuisineString}</div>
  }
  return null
}

export const renderDollars = (restaurant) => {
  return [...Array(restaurant.price_rating)].map((e, i) => (
    <span key={i}>$</span>
  ))
}

export const throttle = (func, wait) => {
  let lastTime = moment()

  return (...args) => {
    const now = moment()
    if (now.diff(lastTime, "milliseconds") >= wait) {
      func(...args)
      lastTime = now
    }
  }
}

export const stars = (restaurant) => {
  const { ratings } = restaurant
  const { Text } = Typography
  if (ratings && ratings["star_rating"] > 0) {
    return (
      <Rate
        allowHalf
        disabled
        defaultValue={restaurant.ratings["star_rating"]}
      ></Rate>
    )
  } else {
    return (
      <Text type="secondary" style={{ color: "grey" }}>
        {" "}
        No ratings
      </Text>
    )
  }
}
export const isClosedRestaurant = (restaurant) => {
  return (
    restaurant["order_time"]["open"] === false ||
    restaurant["order_time"]["delivery"] === false
  )
}
export const isPartnerAway = (partnerScreen, partnerOnline) => {
  return !(
    (partnerScreen === SCREENS.SELECT_RESTAURANT ||
      partnerScreen === SCREENS.PLAN_NEW_DATE ||
      partnerScreen === SCREENS.ADDRESS_WAIT_SCREEN ||
      partnerScreen === SCREENS.SELECT_MENU_ITEMS ||
      partnerScreen === SCREENS.CHECKOUT ||
      partnerScreen === SCREENS.GET_ADDRESS) &&
    partnerOnline
  )
}

// dedupe items in cart and compute their quantity.
export const consolidateItemQuantityInCart = (cart) => {
  const cartItemsQuantityMap = {}
  cart &&
    cart.forEach((item) => {
      cartItemsQuantityMap[item.item_key] = {
        ...item,
        price: (item.price / item.quantity).toFixed(2),
      }
    })
  return Object.values(cartItemsQuantityMap)
}
export const checkCheckoutPartnerAway = (partnerState, dateState) => {
  const payStatus = _.get(dateState, "payStatus.status")
  const partnerOnline = _.get(partnerState, "presence.isOnline", false)
  const partnerScreen = _.get(partnerState, "activeScreen", "")
  return isPartnerAway(partnerScreen, partnerOnline) && payStatus !== "SELF"
}
export const getFirstCaps = (str) => {
  if (!str || _.isEmpty(str)) {
    return null
  }
  if (str.length === 1) {
    return str.toUpperCase()
  }

  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}
// Gets Open Restaurants from a given list of restaurants
export const getOpenRestaurants = (restaurants) => {
  return restaurants.filter((restaurant) => {
    if (
      restaurant["order_time"]["open"] &&
      restaurant["order_time"]["delivery"]
    )
      return restaurant
  })
}

export const getGenderSpecificMessage = (partnerGender, type) => {
  if (type === "POSSESSIVE") {
    // Objective type
    return partnerGender === "MALE"
      ? " his"
      : partnerGender === "FEMALE"
      ? " her"
      : " their"
  } else if (type === "SUBJECTIVE") {
    // Subjective type
    return partnerGender === "MALE"
      ? " He"
      : partnerGender === "FEMALE"
      ? " She"
      : " They"
  } else if (type === "WANT") {
    return partnerGender === "MALE"
      ? " He wants"
      : partnerGender === "FEMALE"
      ? " She wants"
      : " They want"
  } else {
    return partnerGender === "MALE"
      ? " him"
      : partnerGender === "FEMALE"
      ? " her"
      : " them"
  }
}
//get partner's name or nickname
export const getPartnerNameorNickName = (
  partnerState,
  reduxPartner,
  nickName
) => {
  return _.get(partnerState, "userDetails.display_name")
    ? _.get(partnerState, "userDetails.display_name")
    : _.get(reduxPartner, "display_name")
    ? _.get(reduxPartner, "display_name")
    : _.get(nickName, "partner2_nickname", "Partner")
}
// to format mobile number into usa and indian format only
export const formatPhoneNumber = (phoneNumberString) => {
  var cleaned = ("" + phoneNumberString).replace(/\D/g, "")
  let phone = {}
  if (cleaned.slice(0, 2) === "91") {
    let match = cleaned.match(/^(91|)?(\d{5})(\d{5})$/)
    if (match) {
      phone.intlCode = match[1] ? "+91" : ""
      phone.telephoneNumber = [match[2], "-", match[3]].join("")
      return phone
    }
  } else if (cleaned.slice(0, 1) === "1") {
    let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      phone.intlCode = match[1] ? "+1" : ""
      phone.telephoneNumber = [
        "(",
        match[2],
        ") ",
        match[3],
        "-",
        match[4],
      ].join("")
      return phone
    }
  } else {
    return phone
  }
}

export const getQuantityDescription = (minQuantity, maxQuantity, length) => {
  if (minQuantity === 1) {
    return CHOOSE_REQUIRED(minQuantity)
  } else if (minQuantity > 1) {
    return CHOOSE_REQUIRED(minQuantity)
  } else if (maxQuantity !== length) {
    return CHOOSE_MAX(maxQuantity)
  } else {
    return CHOOSE_OPTIONAL
  }
}

export const getNudgeState = (activeScreen) => {
  if (activeScreen === "PLAN_NEW_DATE") return "beforePlanning"
  else if (
    activeScreen === "ADDRESS_WAIT_SCREEN" ||
    activeScreen === "SELECT_RESTAURANT"
  )
    return "untilChooseRestaurant"
  else if (activeScreen === "SELECT_MENU_ITEMS") return "untilCheckout"
  else if (activeScreen === "CHECKOUT") return "untilOrderPlace"
}

export const getChatSpaceName = (dateState, partnerDetails) => {
  return _.get(dateState, "chatSpaceName")
    ? _.get(dateState, "chatSpaceName")
    : _.get(partnerDetails, "chat_space_name")
    ? _.get(partnerDetails, "chat_space_name")
    : DEFAULT_SPACE_NAME
}

export const osType = () => {
  var OSName = "Unknown OS"
  if (navigator.appVersion.indexOf("Win") !== -1) OSName = "Windows"
  if (navigator.appVersion.indexOf("Mac") !== -1) OSName = "MacOS"
  if (navigator.appVersion.indexOf("X11") !== -1) OSName = "UNIX"
  if (navigator.appVersion.indexOf("Linux") !== -1) OSName = "Linux"
  return OSName
}
